function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.137 9.137c0 2.016 1.624 3.65 3.626 3.65 2.003 0 3.627-1.634 3.627-3.65a3.642 3.642 0 00-3.231-3.628c-.087-.01-.852.444-2.297 1.36l-1.725 2.268z",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.958 20.846c.714-1.328.994-2.359.841-3.092-.152-.734.405-.806 1.673-.217-.034 1.657-.13 2.517-.29 2.581-.16.065-.902.307-2.224.728z",
  stroke: "#371447",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.395 47.348c.01-.252-.057-.377-.154-.536-4.085-6.747-10.88-8.48-15.652-10.966-3.19-1.661-5.396-3.737-6.62-6.228a6.085 6.085 0 00.267-1.748 7.787 7.787 0 00-3.873-6.735c-1.027-1.625-3.087-4.114-4.167-4.508-1.08-.394-.476 1.848-.996 3.551a7.802 7.802 0 00-6.207 5.402 7.766 7.766 0 00-.33 1.842c-.836.52-1.555 1.186-1.892 1.581-.304.358-.497.634-.497 1.405 0 2.322 2.272 3.878 5.933 3.957.403.008.743 0 1.029-.027.634.369 1.272.672 1.869.904-1.25 3.632-1.08 7.653.407 11.46.14.36.33.73.33 1.055 1.804-1.268 5.913-.97 12.327.894 6.414 1.865 12.49 1.43 18.226-1.303z",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.395 47.348c.01-.252-.057-.377-.154-.536-4.085-6.747-10.88-8.48-15.652-10.966-3.19-1.661-5.396-3.737-6.62-6.228a6.085 6.085 0 00.267-1.748 7.787 7.787 0 00-3.873-6.735c-1.027-1.625-3.087-4.114-4.167-4.508-1.08-.394-.476 1.848-.996 3.551a7.802 7.802 0 00-6.207 5.402 7.766 7.766 0 00-.33 1.842c-.836.52-1.555 1.186-1.892 1.581-.304.358-.497.634-.497 1.405 0 2.322 2.272 3.878 5.933 3.957.403.008.743 0 1.029-.027.634.369 1.272.672 1.869.904-1.25 3.632-1.08 7.653.407 11.46.14.36.33.73.33 1.055",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  fill: "#FFB74D",
  cx: 13.173,
  cy: 36.519,
  rx: 1.176,
  ry: 1.184
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  cx: 8.272,
  cy: 27.444,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.878 30.611c.441 0 1.295-.568 1.295-1.03 0-.462-.756-.756-1.198-.756-.441 0-.799.374-.799.836 0 .462.26.95.702.95z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.39 46.796c3.518-5.918 4.511-13.528.716-23.983a34.821 34.821 0 00-.966-2.4c-.786-2.32-1.746-4.715-2.845-6.917a6.75 6.75 0 00.091-1.107c0-1.827-.739-3.496-1.961-4.776 1.356-4.02-2.999-8.045-3.234-7.073-.22.913-.05 2.143-1.409 4.668a8.89 8.89 0 00-1.436-.116c-3.253 0-6.054 1.753-7.32 4.275-4.128-.22-6.974.075-8.537.883-.78.365-2.002 5.142 2.595 7.394.354.254 3.052.366 8.097.336.412.313.859.59 1.335.825C32.7 25.698 30.01 30.02 20.45 31.771 10.846 33.529 5.235 38.73 3.614 47.373l-.018.58",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.743 22.415c-3.242 1.865-5.618 2.835-7.126 2.91-1.509.074-3.447-.276-6.357-1.215",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  cx: 28.307,
  cy: 9.839,
  r: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  fill: "#FFB74D",
  cx: 36.801,
  cy: 26.809,
  rx: 1.176,
  ry: 1.184
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.09 12.535c.615 0 1.804-.758 1.804-1.372 0-.615-1.053-1.006-1.668-1.006s-1.113.498-1.113 1.113c0 .614.362 1.265.977 1.265z",
  fill: "#371447"
}));

function SvgPetsMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPetsMd;